import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { ProblemAgitation } from './components/ProblemAgitation';
import { ProductDetails } from './components/ProductDetails';
import { Offer } from './components/Offer';
import { FooterFAQ } from './components/FooterFAQ';
import { PurchasePopup } from './components/PurchasePopup';
const META_PIXEL_ID = '2069197916973057';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    // If fbq already exists (re-render), just track PageView
    if (w.fbq) {
      try {
        w.fbq('track', 'PageView');
      } catch (_) {}
      return;
    }
    // Stub queue so calls before script loads are not lost
    const fbq: any = function () {
      // eslint-disable-next-line prefer-rest-params
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    w.fbq = fbq;
    if (!w._fbq) w._fbq = fbq;
    // Inject the Facebook events script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
    // Initialize + PageView
    try {
      w.fbq('init', META_PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch (_) {}
  }, []);
  return <div className="min-h-screen bg-brand-cream font-body selection:bg-brand-orange selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <ProblemAgitation data-id="element-3" />
      <ProductDetails data-id="element-4" />
      <Offer data-id="element-5" />
      <FooterFAQ data-id="element-6" />
      <PurchasePopup data-id="element-7" />
    </div>;
}